export default {
  form: {
    owner_phone_number: {
      label: 'Número de telefone do contacto',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'Email do contacto',
      placeholder: 'Introduzir email',
    },
    owner_first_name: {
      label: 'Nome',
      placeholder: 'Introduzir nome',
    },
    owner_last_name: {
      label: 'Apelido',
      placeholder: 'Introduzir apelido',
    },
    owner_dob: {
      label: 'Data de nascimento',
      placeholder: 'Data',
    },
    owner_id_number: {
      label: 'Número de identificação (ex.: número de segurança social nos EUA)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Voltar',
    next: 'Seguinte',
  },
};
